import { OrganizationEdit } from 'src/app/organization/model/organizationEdit';
import { User } from 'src/app/user/model/user';

export class IntegrityEdit
{
    public id = null;
    public version = 0;
    public locked = false;
    public integrityStage = '';
    public integrityType = '';
    public integrityTypeName = '';
    public comments = '';
    public userSelection = '';
    public validationErrors = false;
    public automaticValidations = false;
    public automaticDiscardOnError = false;
    public users: User[] = [];
    public organizations: OrganizationEdit[] = [];
    public fromDateSelection = null;
    public toDateSelection = null;
    public lastNameSelection = '';
}

export interface InegrityList
{
    id: number;
    integrityType: string;
    integrityTypeName: string;
    comments: string;
    lastModifiedBy: string;
    lastModifiedDate: Date;
}
